import React from "react";
import TopBarLogoSvg from "../../assets/svgicons/OTP-icon-top-bar-logo.svg";

const TopBarLogoIcon = (props) => {
  return <img src={TopBarLogoSvg} width={130} alt="TopBarLogo" />;
};

export default TopBarLogoIcon;
